import { useTranslation } from 'react-i18next';

export const TextAreaField = ({ required, id, label, labelKey, maxLength, placeholder, input, touched, error, meta, autoFocus, readOnly, disabled }: any) => {
    const { t } = useTranslation();
    return (
        <div
            id={ id && `${id}-field` }
            className={ `${required ? 'required' : ''} field text-field` }
        >
            { (label || labelKey) &&
                <label
                    htmlFor={ id }
                    className={ disabled ? 'disabled' : undefined }
                >
                    { label || t(labelKey) }
                </label>
            }
            <textarea
                id={ id }
                { ...input }
                autoFocus={ autoFocus }
                readOnly={ readOnly }
                disabled={ disabled }
                placeholder={ placeholder }
                maxLength={ maxLength }
            />
            { touched && error && <div className="error">{ meta.error }</div> }
        </div>
    );
};
